import React from 'react';
import UseTerms from 'components/UseTerms';
import i18n from 'i18n';
import useTitle from 'utils/hook/useTitle';

export const UseTermsPage = () => {
  useTitle(i18n.t('MB_T_USE_TERMS'));

  return <UseTerms />;
};

export default UseTermsPage;
